import styled from 'styled-components';
import { Main } from '@libs/uikit/Components';

export const StyledMain = styled(Main)`
    margin: 0;
    border-bottom: 1px solid #e9ebec;
    padding: 0;
`;
